import AgingReportShell from './AgingReportShell';

// ─────────────────────────────────────────────────────────────────
// Glass-i — Debtors Aging page (Stage 6E.3).
//
// Customer outstanding broken into aging buckets. Read-only. Reads
// posted accounting_voucher_lines on debtor (sundry_debtor) ledgers,
// applies FIFO allocation between debits (invoices) and credits
// (receipts), and bucket-splits the remaining open lines.
// ─────────────────────────────────────────────────────────────────

export default function DebtorsAgingPage() {
  return (
    <AgingReportShell
      reportType="debtors"
      title="Debtors Aging"
      subtitle="Track customer outstanding and overdue receivables."
      partyColumnTitle="Customer / Ledger"
      emptyContextKey="debtors_aging"
      errorContextKey="debtors_aging"
      totalCardLabel="Total Receivables"
    />
  );
}
